<template>
  <div>
    <multiselect
      v-model="selected"
      :options="options"
      :custom-label="customLabel"
      :loading="false"
      track-by="id"
      :disabled="disable"
      @remove="emitClear"
    >
      <div slot="noResult">
        No Case Managers to display.
      </div>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import _ from 'lodash';
import {mapActions, mapGetters} from 'vuex';
import {HTTP} from '@/http-common';

export default {
  props: ['value', 'disable'],
  components: {Multiselect},
  data() {
    return {
      selected: null,
      options: [],
      loading: false
    }
  },
  mounted() {
    this.loadCaseManagers();
  },
  computed: {
    ...mapGetters([
      'getCaseManagers'
    ]),
    same: function () {
      return this.options.includes(this.selected);
    }
  },
  methods: {
    ...mapActions([
      'loadCaseManagers'
    ]),
    customLabel(option) {
      return `${option.full_name}`
    },

    matchSelected() {
      if (this.loading) {
        return;
      }

      let id = parseInt(this.value);

      this.selected = _.find(this.options, ["id", id]);

      if (this.selected == null && Number.isInteger(id)) {
        this.loading = true;
        HTTP.get('case-manager-data/' + this.value).then(response => {
          // do not add case manager to list if its already there to avoid duplicates
          if (!this.options.find((manager) => manager.id === response.data.data.data.id)){
            this.options.push(response.data.data.data);
          }
          this.selected = this.options.find((manager) => manager.id === response.data.data.data.id);
          this.loading = false;
        });
      }

      if (this.selected != null) {
        this.$emit('input', this.selected.id);
      }
    },
    emitClear() {
      this.$emit('input', '');
    }
  },
  watch: {
    selected: function () {
      if (this.selected != null)
        this.$emit('input', this.selected.id);
    },
    value: function () {
      this.matchSelected();
    },
    getCaseManagers: function () {
      this.options = this.getCaseManagers;
      this.matchSelected();
    }
  }
}
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.multiselect {
  height: 34px;
}

.multiselect__select {
  height: 34px;
  width: 34px;
}

.multiselect__tags {
  height: 34px;
  min-height: 34px;
  padding: 6px 40px 0 12px;
}

.multiselect--disabled {
  background-color: #eef1f5;
  min-height: 34px;

  .multiselect__select {
    background-color: #eef1f5;
    top: 0;
  }

  .multiselect__tags, .multiselect__single {
    background-color: #eef1f5;
  }
}

.multiselect--disabled .multiselect__tags {
  background-color: #eef1f5;
}

.multiselect__placeholder {
  padding: 0;
}
.multiselect__single {
  font-size: 14px;
  padding: 0;
}
.multiselect__input {
  padding: 0;
  font-size: 14px;
}
.multiselect__option {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// CaseMenagers.vue?36f8bf46